'use client';

// Refresh the page on changes in the content folder, as detected by watch-content.ts
// See https://github.com/gaearon/overreacted.io/pull/797 for the original implementation

import * as React from 'react';

interface WatchedContentProps {
  port: number;
  reload: () => void;
}

let WatchedContent: React.FC<WatchedContentProps> = () => null;

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line react/display-name
  WatchedContent = ({ port, reload }) => {
    React.useEffect(() => {
      const ws = new WebSocket(`ws://localhost:${port}`);

      ws.onmessage = (event) => {
        if (event.data === 'refresh') {
          reload();
        }
      };

      return () => {
        if (ws.readyState === ws.OPEN) {
          ws.close();
        }
      };
    }, [port, reload]);

    return null;
  };
}

export { WatchedContent };
